/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type program_QueryVariables = {};
export type program_QueryResponse = {
    readonly events: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"ProgramView_events">;
    }> | null;
    readonly currentMetaData: {
        readonly " $fragmentRefs": FragmentRefs<"ProgramView_currentMetaData">;
    };
    readonly programPage: {
        readonly title: string;
        readonly description: string | null;
        readonly sharingImage: string | null;
        readonly " $fragmentRefs": FragmentRefs<"PageView_page">;
    } | null;
};
export type program_Query = {
    readonly response: program_QueryResponse;
    readonly variables: program_QueryVariables;
};



/*
query program_Query {
  events {
    ...ProgramView_events
    id
  }
  currentMetaData {
    ...ProgramView_currentMetaData
    id
  }
  programPage: page(slug: "program") {
    ...PageView_page
    title
    description
    sharingImage
    id
  }
}

fragment PageView_page on Page {
  id
  content
  slug
  title
  dateSaved
  dateCreated
  videoFile
}

fragment ProgramView_currentMetaData on MetaData {
  year
  startDate
  endDate
}

fragment ProgramView_events on Event {
  title
  id
  timeStart
  timeEnd
  coverImage
  description
  location
  date
  type
  company {
    id
    name
  }
  usesTickets
  maxParticipants
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "slug",
    "value": "program"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharingImage",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "program_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "events",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProgramView_events"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProgramView_currentMetaData"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "programPage",
        "args": (v0/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PageView_page"
          }
        ],
        "storageKey": "page(slug:\"program\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "program_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "events",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coverImage",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usesTickets",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxParticipants",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "year",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "programPage",
        "args": (v0/*: any*/),
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateSaved",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoFile",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": "page(slug:\"program\")"
      }
    ]
  },
  "params": {
    "cacheID": "7481e7dc7fd4ff103a8a84d1ce35f7f2",
    "id": null,
    "metadata": {},
    "name": "program_Query",
    "operationKind": "query",
    "text": "query program_Query {\n  events {\n    ...ProgramView_events\n    id\n  }\n  currentMetaData {\n    ...ProgramView_currentMetaData\n    id\n  }\n  programPage: page(slug: \"program\") {\n    ...PageView_page\n    title\n    description\n    sharingImage\n    id\n  }\n}\n\nfragment PageView_page on Page {\n  id\n  content\n  slug\n  title\n  dateSaved\n  dateCreated\n  videoFile\n}\n\nfragment ProgramView_currentMetaData on MetaData {\n  year\n  startDate\n  endDate\n}\n\nfragment ProgramView_events on Event {\n  title\n  id\n  timeStart\n  timeEnd\n  coverImage\n  description\n  location\n  date\n  type\n  company {\n    id\n    name\n  }\n  usesTickets\n  maxParticipants\n}\n"
  }
};
})();
(node as any).hash = '7ad26d5c9e8feca6de0a5926fd8b49e6';
export default node;
